module.exports = "<div class=\"inner\">\n  <router-outlet></router-outlet>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/base-app/components/content-container/content-container.component.html
// module id = ../../../../../src/app/modules/base-app/components/content-container/content-container.component.html
// module chunks = main